<template>
  <header class="header">
    <div class="inner">
      <div class="nav">
        <div class="brand" @click="$router.push('/')">
          <span class="brand-text">TaskLink</span>
        </div>
        <div>
          <RouterLink class="nav-link" to="/home">首页</RouterLink>
          <RouterLink class="nav-link" to="/talent">人才库</RouterLink>
          <RouterLink class="nav-link" to="/tasks">找工作</RouterLink>
        </div>

      </div>

      <div class="actions">
        <RouterLink class="action-link" to="/publish-task">发布任务</RouterLink>
        <RouterLink class="action-link" to="/talent">入驻人才库</RouterLink>
        <RouterLink class="action-link" to="/login">登 录</RouterLink>
        <RouterLink class="action-link btn" to="/register">注 册</RouterLink>
        <!-- <RouterLink class="user action-link" to="/profile"> 
            <img class="avatar"
                    src="https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=200&q=80"
                    alt="" />       
              <span class="email ">{{ userEmail }}</span>           
          </RouterLink> -->
      </div>
    </div>
    <!-- <div class="divider"></div> -->
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      // 你后面接入真实登录态就把它换成 store / pinia / api
      userEmail: '123@126.com',
    }
  },
}
</script>

<style scoped>
.header {
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 20;
  width: 100%;
  padding: 24px clamp(24px, 6vw, 240px);
}

.inner {
  width: 100%;
  /* margin: 0 auto; */
  /* padding: 49px 240px; */
  display: flex;
  align-items: center;
  justify-content: space-between;
  /* gap: 24px; */
}

.brand {
  cursor: pointer;
  user-select: none;
  margin-right: 120px;
}

.brand-text {
  font-family: 'Playfair Display', serif;
  font-weight: 500;
  font-size: 36px;
  color: #333333;
}

.nav {
  display: flex;
  align-items: center;
  gap: 0;
  flex: 1;
  /* justify-content: center; */
}

.nav-link {
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  margin-right: 40px;
}

.nav-link.router-link-active {
  /* color: #2f9f35;
    font-weight: 700;
    background: #effbf0; */
}

.actions {
  display: flex;
  align-items: center;
  /* gap: 18px; */
}

.action-link {
  color: #333;
  text-decoration: none;
  font-size: 16px;
  margin-left: 50px;
  /* padding: 6px 8px;
    border-radius: 8px; */
}

.btn {
  width: 124px;
  height: 50px;
  background: #4CAF50;
  border-radius: 8px 8px 8px 8px;
  font-weight: 500;
  font-size: 16px;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
}

.action-link.router-link-active {
  color: #2f9f35;
  font-weight: 700;
}

.user {
  display: flex;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  /* background: linear-gradient(135deg, #c9c9c9, #9a9a9a); */
}

.email {
  /* font-size: 13px;
    color: #444; */
}

.divider {
  height: 1px;
  background: #e9e9e9;
}
</style>